import React from "react";

import styles from "./style.module.scss";
import { LocalisedText } from "../../i18n";

const LoadingScreen: React.FC = () => {
  return (
    <div className={styles.loadingScreen}>
      <div className={styles.loadingIndicator}>
        <div className={styles.loadingIcon} />
        <div className={styles.loadingText}>
          <LocalisedText id="screen.loadingScreen.loading" />
        </div>
      </div>
    </div>
  );
};

export default LoadingScreen;
